module.exports = __webpack_public_path__ + "media/images/top-logo@2x-ae4c669290e08b8ef20f06671027df87.png";